module.exports = __webpack_public_path__ + "static/media/intersect-4.77cfa96f.svg";